import React, { Component } from 'react'
import { AudioSpectrumProps } from './types'

/** Displays the inputted audio data on canvas */
class AudioSpectrum extends Component<AudioSpectrumProps> {

  private canvasRef: React.RefObject<HTMLCanvasElement> | null = null
  private ctx: CanvasRenderingContext2D | null = null

  constructor (props) {

    super(props)
    this.canvasRef = React.createRef<HTMLCanvasElement>()

  }

  componentDidUpdate () {

    this.drawSpectrum()

  }

  drawSpectrum = () => {

    if (!this.canvasRef || !this.canvasRef.current) return

    this.ctx = this.canvasRef.current.getContext('2d')

    if (!this.ctx) return
    if (typeof this.ctx.fillStyle !== 'undefined') this.ctx.fillStyle = this.props.meterColor || '#003CB2'

    const step = Math.round(this.props.audioData.length / this.props.meterCount) // sample limited data from the total array
    this.ctx.clearRect(0, 0, this.canvasRef.current.width, this.canvasRef.current.height)

    for (let i = 0; i < this.props.meterCount; i++) {

      this.drawBar(i, this.props.audioData[i * step])

    }

  }

  drawBar = (i, value) => {

    if (!this.canvasRef || !this.canvasRef.current || !this.ctx) return

    const y = (270 - value) * this.canvasRef.current.height / 270
    this.ctx.fillRect(i * (this.props.meterWidth + this.props.gap), this.canvasRef.current.height - 2, this.props.meterWidth, 2)
    this.ctx.fillRect(i * (this.props.meterWidth + this.props.gap), y, this.props.meterWidth, this.canvasRef.current.height)

  }

  render () {

    return <canvas width={this.props.width} height={this.props.height} ref={this.canvasRef} data-bdd="audio-spectrum"/>

  }

}

export default AudioSpectrum
